export default __webpack_public_path__ + "static/media/6.3919f327.png";